import { render, staticRenderFns } from "./BaseSelector.vue?vue&type=template&id=12186f40&scoped=true"
import script from "./BaseSelector.vue?vue&type=script&lang=ts"
export * from "./BaseSelector.vue?vue&type=script&lang=ts"
import style0 from "./BaseSelector.vue?vue&type=style&index=0&id=12186f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12186f40",
  null
  
)

export default component.exports